import { ReactNode }              from 'react';
import { observer }               from 'mobx-react-lite';
import Popover                    from '@widesk-ui/components/Popover';
import { TooltipPlacement }       from '@widesk-ui/components/Tooltip';
import MapMenu                    from '@/TokamapEditor/ux/MapMenu';
import currentProjectEditorStore  from '@/TokamapEditor/stores/currentProjectEditorStore';
import leftSidebarStore           from '@/TokamapEditor/stores/leftSidebarStore';
import { MapMenuTrigger }         from '@/TokamapEditor/stores/ProjectEditorStore';

type Props = {
	source: MapMenuTrigger;
	placement: TooltipPlacement;
	children: ReactNode;
};

const MapMenuPopover = observer(({ source, placement, children }: Props) => {
	const projectEditor = currentProjectEditorStore.get;
	const open = projectEditor.mapMenuOpenedFrom === source;

	return (
		<Popover
			trigger="click"
			placement={placement}
			autoAdjustOverflow={{ shiftX: true }}
			open={open}
			onOpenChange={opened => {
				if (opened) {
					leftSidebarStore.close();
				}

				projectEditor.setMapMenuOpenedFrom(opened ? source : null);
			}}
			content={<MapMenu key={open ? 'open' : 'closed'} />}
			styles={{ body: { padding: 0 } }}
		>
			{children}
		</Popover>
	);
});

export default MapMenuPopover;
